import { Helmet } from "react-helmet";
import SubHeader from "../components/global/SubHeader";
import AdminLayoutProps from "../services/models/adminLayoutProps.model";
import { useContext, useEffect } from "react";
import { ApplicationState } from "../services/context/ApplicationStateContext";
import InfoSlider from "../components/global/InfoSlider";
import { useHistory } from "react-router-dom";

function AdminContentLayout({
  subHeaderTitle,
  customButtons,
  redirect,
  children,
  rightSectionClassName = "",
  loading,
  pageTitle,
  showButtonInSubheaderForMobile,
  hideSubHeaderSelectors,
  hideTitleAndRedirect,
  subHeaderContainerClassName,
}: Readonly<AdminLayoutProps>): JSX.Element {
  const {
    state: { showInfoSlider },
    dispatch,
  } = useContext(ApplicationState);
  const history = useHistory()
  const isOrderCreatedScreen = history?.location?.pathname === '/access/online-order/order-created' 
  return (
    <main
      className={`row-[span_9000_/_span_9000] ${isOrderCreatedScreen ? 'overflow-hidden' : 'overflow-auto'} ${rightSectionClassName}`}
    >
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <div className="h-full grid grid-rows-twoRowLayout">
        <SubHeader
          title={subHeaderTitle}
          customButtons={customButtons}
          reDirect={redirect}
          hideSubHeaderSelectors={hideSubHeaderSelectors}
          hideTitleAndRedirect={hideTitleAndRedirect}
          containerClass={subHeaderContainerClassName}
          showButtonInSubheaderForMobile={showButtonInSubheaderForMobile}
          loading={loading}
        />
        {children}
        {showInfoSlider && <InfoSlider />}
      </div>
    </main>
  );
}

export default AdminContentLayout;
